export const profileReducer = (state = {profile: {}}, action) => {
    switch(action.type){
        case 'UPDATE_PROFILE': return {...state, profile: action.payload.profile}
        default: return state
    }
}
